<template>
    <b-link router-tag="a" :to="{name: type, params: {slug: item.slug} }" 
        class="mb-2 pl-xl-2 pr-xl-2 pl-1 pr-1" :class="{'col-xl-8': large && noGrid, 'col-xl-4': !large && noGrid}" 
        v-if="item && item.better_featured_image"
    >
        <div class="mb-4 filter-bg">
            <div class="d-flex align-items-end bg height-553 border-round height-mobile btn-pointer bg-center"
                :style="`background-image: url(${item.better_featured_image.source_url}); background-repeat: no-repeat; background-size: cover;`">
                <div class="filter-bg" :style="`width: 100%;`">
                    <div class="container-fluid ml-xl-4 mb-xl-0 pl-xl-1 pr-xl-5 ml-2 font-glacial-bold text-white titulo" v-html="item.title.rendered.substr(0,40) + '...' "></div>

                    <div class="ml-xl-4 mb-xl-4 mt-xl-2 ml-xl-4 pl-xl-1 mb-4 ml-4 mt-2 font-regular categories" v-if="cat">
                        {{cat}}
                    </div>
                    <div class="ml-xl-4 mb-xl-4 mt-xl-2 ml-xl-4 pl-xl-1 mb-4 ml-4 mt-2 font-regular categories" v-else-if="item.pure_taxonomies.categories">
                        {{item.pure_taxonomies.categories[0].name}}
                    </div>
                </div>
            </div>
        </div>    
  
    </b-link>
    
</template>

<script>
export default {

    props:{
        large: { type:Boolean, default: false },
        noGrid: { type:Boolean, default: false },
        type: { type: String, default: 'materia' },
        item: null,
        cat: null,
    },

    methods:{
        routeTo(obj){
            this.$router.push(obj)
    
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/components/widgets/blog-item.vue